import { Component, HostListener, OnInit } from '@angular/core';

@Component({
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
    sideBarOpen = true;
    showFiller = false;

    mobileQuery: MediaQueryList;

    private innerWidth = 0;

    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        this.checkSize();
    }

    constructor() { }

    ngOnInit(): void {
        this.checkSize();
    }

    private checkSize(): void {
        if (window.innerWidth !== this.innerWidth) {
            this.innerWidth = window.innerWidth;

            if (window.innerWidth < 1000) {
                this.sideBarOpen = false;
            } else {
                this.sideBarOpen = true;
            }
        }
    }

    public sideBarToggler(e: any): void {
        this.sideBarOpen = !this.sideBarOpen;
    }
}
